import { render } from "./AboutQuantumCareerChatbot.vue?vue&type=template&id=08f1cab6"
import script from "./AboutQuantumCareerChatbot.vue?vue&type=script&lang=js"
export * from "./AboutQuantumCareerChatbot.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__